import React, { useState, useEffect, useCallback } from 'react';
import introGlitchAudio from '../assets/introglitch.mp3'; 
import cashisDeadAudio from '../assets/cashisdead.mp3';
import fireBurnAudio from '../assets/fireburn.mp3';

const AudioPlayer = () => {
  const [audioStarted, setAudioStarted] = useState(false);

  const audioState = useState({
    introAudio: new Audio(introGlitchAudio),
    mainAudio: new Audio(cashisDeadAudio),
    fireAudio: new Audio(fireBurnAudio),
  })[0];

  const startAudio = useCallback(() => {
    const { introAudio, mainAudio, fireAudio } = audioState;

    introAudio.play()
      .catch(error => console.error('Error playing intro:', error));

    introAudio.onended = () => {
      mainAudio.loop = true;
      fireAudio.loop = true;

      mainAudio.play()
        .catch(error => console.error('Error playing main audio:', error));

      fireAudio.volume = 0.5;
      fireAudio.play()
        .catch(error => console.error('Error playing fire audio:', error));
    };

    setAudioStarted(true);
  }, [audioState]);

  const stopAudio = useCallback(() => {
    const { introAudio, mainAudio, fireAudio } = audioState;

    introAudio.pause();
    mainAudio.pause();
    fireAudio.pause();

    setAudioStarted(false);
  }, [audioState]);

  useEffect(() => {
    return () => {
      const { introAudio, mainAudio, fireAudio } = audioState;
      introAudio.pause();
      mainAudio.pause();
      fireAudio.pause();
    };
  }, [audioState]);

  return (
    <button onClick={audioStarted ? stopAudio : startAudio} className="connect-button">
      {audioStarted ? "🔊" : "🔇"}
    </button>
  );
};

export default AudioPlayer;
